<template lang="pug">
el-form(ref="form" @submit.native.prevent='' label-position="top" :rules="rules" :model="survey")
  el-row(:gutter="40")
    el-col.margin(:lg="15")
      el-form-item(label="Title" prop="title")
        el-input(v-model.trim="survey.title" size="large")

      el-form-item(label="Briefing message")
        el-input(type='textarea' :autosize="{ minRows: 6, maxRows: 20}" v-model.trim="survey.content")

      el-form-item(label="Set a target number of surveys to be completed" prop="targetNumReplies")
        el-input(v-model.number="survey.targetNumReplies" size="large")

      h3.questions-title Fields

      el-alert(v-if='disableFieldEditing' type='info' :style='{ marginBottom: "20px" }' :closable="false"
              title='This survey has already some responses, fields cannot be edited.')

      el-alert(v-if='formSubmitted && !survey.fields.length' :closable='false' type='error' title='Please enter at least one field')

      fields-editor(:fields='survey.fields' :disabled='disableFieldEditing')

    el-col(:lg="9")
      scheduler(v-if='survey' v-model='survey' @save='onSave' :show-delete='!create' @delete='onDelete'
        :show-recurring-options='false' ref='scheduler' label='survey' :form-submitted='formSubmitted')

        template(slot='middle')
          .side-title Who would you like to see this survey?
          assignee-picker(:assignees.sync='assignees')

</template>

<script>
import AssigneePicker from "@/brapp/components/shared/AssigneePicker";
import Scheduler from "@/brapp/components/shared/Scheduler";
import FieldsEditor from "../FieldsEditor";

export default {
  components: { AssigneePicker, Scheduler, FieldsEditor },
  model: {
    prop: "survey",
    event: "change"
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    survey: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formSubmitted: false,
      rules: {
        title: [{ required: true, message: "Required field", trigger: "blur" }],
        targetNumReplies: [
          {
            required: true,
            type: "number",
            message: "Required field",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    assignees: {
      get() {
        return {
          users: this.survey.assignees.filter(a => a.user).map(a => a.user),
          appLicenseGroups: this.survey.assignees
            .filter(a => a.appLicenseGroup)
            .map(a => a.appLicenseGroup)
        };
      },
      set(val) {
        this.survey.assignees = val.users
          .map(u => ({ user: u }))
          .concat(val.appLicenseGroups.map(g => ({ appLicenseGroup: g })));
      }
    },
    disableFieldEditing() {
      return this.survey.completedCount > 0;
    }
  },
  methods: {
    onSave() {
      this.formSubmitted = true;
      this.$refs.form.validate(valid => {
        if (this.$refs.scheduler.datesValid) {
          this.$emit("save", { valid });
        } else {
          this.$emit("save", { valid: false });
        }
      });
    },
    onDelete() {
      this.$emit("delete");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/scss/mixins.scss";

.questions-title {
  margin: 20px 0;
}

.side-title {
  margin: 20px 0 10px 0;
  font-size: 16px;
  font-weight: 500;
}

.question-editor-panel {
  background: white;
  padding: 30px 20px;
  border: 1px solid #ddd;
  border-radius: 2px;
}

.uploader {
  :global(.el-upload) {
    display: block;
  }
  :global(.el-upload-dragger) {
    width: 100%;
    border: 1px solid #ddd;
    padding: 0 40px;
    border-radius: 2px;
  }
}
@include MQ(ML) {
  .margin {
    margin-bottom: 20px;
  }
}
</style>
